var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationProvider", {
    ref: "provider",
    attrs: {
      mode: _vm.eagerIfDirty,
      vid: _vm.name,
      name: _vm.validateAs,
      rules: _vm.rules,
      bails: false,
      tag: "div"
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var classes = ref.classes
          var errors = ref.errors
          return [
            _vm.label
              ? _c(
                  "label",
                  {
                    staticClass: "mb-[8px] block",
                    class: [classes],
                    attrs: { for: "id_" + _vm.name }
                  },
                  [
                    _vm._v("\n        " + _vm._s(_vm.label) + "\n        "),
                    (_vm.rules &&
                      typeof _vm.rules === "string" &&
                      _vm.rules.includes("required")) ||
                    (typeof _vm.rules === "object" && _vm.rules.required)
                      ? _c("span", { staticClass: "text-red" }, [_vm._v("*")])
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "relative flex items-center gap-[16px]" },
              _vm._l(_vm.options, function(option) {
                return _c(
                  "label",
                  {
                    staticClass: "checkbox-inline flex gap-[8px] items-center"
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localValue,
                          expression: "localValue"
                        }
                      ],
                      attrs: { type: "checkbox", id: option },
                      domProps: {
                        value: option,
                        checked: Array.isArray(_vm.localValue)
                          ? _vm._i(_vm.localValue, option) > -1
                          : _vm.localValue
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.localValue,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = option,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.localValue = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.localValue = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.localValue = $$c
                          }
                        }
                      }
                    }),
                    _c("span", [_vm._v(_vm._s(option))])
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.showError &&
            errors[0] &&
            ((classes.dirty && _vm.validAtleastOnce) || _vm.formValdiated)
              ? _c("span", { staticClass: "text-red mt-8 block text-12" }, [
                  _vm._v(_vm._s(errors[0]))
                ])
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }